import { useQuery } from "react-query";
import { getOfficeBMO } from "../../../../../actions/Utilities/OfficeBMO";

export default function useGetOfficeBMO() {
  return useQuery("GetOfficeBMO", getOfficeBMO, {
    refetchOnWindowFocus: false,
  });
}
